<edl-modal-details
    [title]="'User Request Details'"
    [isReadOnly]="isReadOnly"
    [navigationSections]="navigationSections"
    [startingNavigationItemId]="navigationItemId"
></edl-modal-details>
